import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { FormBuilder } from '@angular/forms';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';
import { DeclaracionCentroDTO, DeclaracionEnvaseControllerService } from 'api-rest';
import { DownloadService } from '../../..//services/download.service';
import { ImportResultDialogComponent } from '../import-result-dialog/import-result-dialog.component';

@Component({
  selector: 'app-upload-center-dialog',
  templateUrl: './upload-center-dialog.component.html',
  styleUrls: ['./upload-center-dialog.component.scss']
})
export class UploadCenterDialogComponent implements OnInit {

  declaracionAdherido: any;
  declaracionCentro: DeclaracionCentroDTO | undefined;
  titulo = "Importar declaración de envases";
  nombreArchivo: string = '';
  file: File | undefined;
  @ViewChild('fileInput') fileInput: any;


  constructor(
    public dialogRef: MatDialogRef<UploadCenterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private FormBuilder: FormBuilder,
    private snackBarSrv: SnackbarService,
    public spinnerSrv: SpinnerService,
    public declaracionEnvaseService: DeclaracionEnvaseControllerService,
    private downloadService: DownloadService,
    private dialog: MatDialog,
  ) {
    this.declaracionAdherido = this.data.declaracionAdherido;
    this.declaracionCentro = this.data.declaracionCentro;
  }

  ngOnInit() {
  }


  adjuntar() {
    this.fileInput.nativeElement.click();
  }

  handleFileInput(event: any) {
    this.file = event.target.files[0];
    if (this.file && this.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      this.nombreArchivo = this.file.name;
      this.snackBarSrv.showSnackBar('Se ha adjuntado el archivo Excel correctamente.', 'success');
    } else {
      this.snackBarSrv.showSnackBar('Por favor, seleccione un archivo Excel (.xlsx).', 'error');
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  Importar() {
    if (!this.file) {
      return;
    }
    Swal.fire({
      text: 'Al realizar una nueva carga se eliminarán todas las líneas previamente declaradas. Si desea mantenerlas, puede exportarlas previamente.',
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Aceptar',
      denyButtonText: 'Cancelar',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.ejecutarImportacion();
      }
    });
  }

  private ejecutarImportacion() {
    if(this.file) {
      this.spinnerSrv.loadingShow();
      this.declaracionEnvaseService.importDeclaracionEnvases(this.declaracionCentro!.id!,  this.file ).subscribe({
        next: res => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar('Importación realizada correctamente', 'success');
          this.dialogRef.close(true);
        },
        error: error => {

          if(error.error){
            this.spinnerSrv.loadingHide();
            this.dialog.open(ImportResultDialogComponent, {
              width: '800px',
              data: error.error
            });
          }
        else {
            this.snackBarSrv.showSnackBar('Ha ocurrido un error al importar la plantilla. Por favor, contacte con el administrador de sistemas', 'error');
          }
          this.spinnerSrv.loadingHide();

        }
      })
    }
  }


  descargar() {
    this.spinnerSrv.loadingShow();
    this.declaracionEnvaseService.exportDeclaracionEnvasesTemplate('response').subscribe({
      next: res => {
        const templateName = this.downloadService.getFileName(res.headers);
        this.downloadService.downloadBlob(res.body!, templateName!);
        this.spinnerSrv.loadingHide();
      },
      error: error => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Ha ocurrido un error al descargar la plantilla', 'error');
      }
    })
  }
}
